import { IShortLicenseInfo } from "@models/dto/Rocketta/LicenseServer/Models/Licenses/IShortLicenseInfo";
import { IResponseModel } from "@models/dto/Rocketta/LicenseServer/Models/IResponseModel";
import { AxiosResponse } from "axios";
import LicenseServerBaseApi from "./baseApi";
import { IIssueLicenseRequest } from "@models/dto/Rocketta/LicenseServer/Models/Licenses/IIssueLicenseRequest";
import { ILicenseInfo } from "@models/dto/Rocketta/LicenseServer/Models/Licenses/ILicenseInfo";

export class LicensesApi {
  static getLicenses(): Promise<AxiosResponse<IResponseModel<IShortLicenseInfo[]>>> {
    return LicenseServerBaseApi.get<IShortLicenseInfo[]>("/license/licenses");
  }

  static issueLicense(data: IIssueLicenseRequest): Promise<AxiosResponse<IResponseModel<ILicenseInfo>>> {
    return LicenseServerBaseApi.postWrapped<ILicenseInfo>("/license/IssueLicense", data);
  }

  static getLicensesByCustomer(customerId: number): Promise<AxiosResponse<IResponseModel<IShortLicenseInfo[]>>> {
    return LicenseServerBaseApi.get<IShortLicenseInfo[]>(`/license/ByCustomer?CustomerId=${customerId}`);
  }
}
